'use client'
import { ArticleCardData } from '@/globalTypes';
import { useEffect, useRef, useState } from 'react';
import { getArticle, getArticleById } from '@/services/app.services';
import { useSearchParams } from 'next/navigation';
import dynamic from 'next/dynamic';
const ArticleContent = dynamic(() => import('@/components/Articles/ArticleContent'))

const EMPTY_ARTICLE: ArticleCardData = {
  id: 0, attributes: {
    title: '',
    Created: '',
    content: [],
    createdAt: '',
    updatedAt: '',
    publishedAt: '',
    locale: '',
    heading: ''
  }
};

export const ArticleView = ({ articleSlug, initialArticle, headerLocale }: { articleSlug: string, initialArticle?: ArticleCardData, headerLocale?: string }) => {
  const searchParams = useSearchParams();
  const localeParam = searchParams.get('locale') || headerLocale || 'en';

  const [locale, setLocale] = useState(localeParam);
  // Seed from the server-fetched article (when provided) so the title (<h1>) and body
  // are present on first paint. Callers that don't pass initialArticle fall back to
  // the client fetch below. The locale switcher always re-fetches on the client.
  const [articleData, setarticleData] = useState<ArticleCardData>(initialArticle ?? EMPTY_ARTICLE)
  const isFirstRender = useRef(true);

  useEffect(() => {
    setLocale(localeParam);
  }, [localeParam]);

  useEffect(() => {
    // Skip the redundant client fetch on first render only when the server already
    // supplied the article for the initial locale; then re-fetch on locale changes.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (initialArticle) return;
    }
    (async () => {
      let data = await (Boolean(parseInt(articleSlug)) ? getArticleById(articleSlug, locale) : getArticle(articleSlug.replaceAll("-", " ").toLowerCase(), locale));
      setarticleData(data);
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleSlug, locale])

  return (
    <div className='article-view  min-h-screen grid p-6 overflow-auto md:justify-center  '>
      <div className='article-content  bg-white   rounded-2xl  text-black p-6  md:w-[45rem] lg:w-[55rem] xl:w-[65rem] 2xl:w-[75rem] shadow-articleCard'>
        <div className='article-heading my-4 flex items-center justify-between'>
          <h1 className='text-2xl font-bold text-[#1D4749]'>{articleData?.attributes.title}</h1>
        </div>
        {
          articleData?.attributes?.content.map((contentBlock, index) => {
            return <ArticleContent key={index} contentBlock={contentBlock} index={index} articleId={parseInt(articleSlug)} />
          })
        }

      </div>
    </div>
  )
} 